import _ from 'lodash';
import moment from 'moment';

// VIP-42789
class DataLayer {
  constructor() {
    this.pushImpl = null;
  }

  init(push) {
    this.pushImpl = push;
  }

  push(data, customDimensions = {}) {
    if (!this.pushImpl) {
      return;
    }

    this.pushImpl(Object.assign(data, customDimensions));
  }

  trackThubnailClick(page, list, position, customDimensions) {
    this.push(
      {
        event: 'thumbnail click',
        eventData: {
          category: 'click',
          action: page,
          label: list,
          value: position,
        },
      },
      customDimensions,
    );
  }

  trackVideoError(message, customDimensions) {
    this.push(
      {
        event: 'video message',
        eventData: {
          category: 'video',
          action: 'message',
          label: message,
        },
      },
      customDimensions,
    );
  }

  trackSearch(searchQuery) {
    this.push({ event: 'virtual pageview', searchQuery });
  }

  trackEmptySearch() {
    this.push({
      event: 'virtual pageview',
      eventData: {
        category: 'message',
        action: 'search page',
        label: 'no result',
      },
    });
  }
}

export function getCustomDimensions({
  article,
  video,
  country,
  embed,
  cuePoints,
}) {
  const publishDate = _.get(article, 'settings.publishTimestamp');
  const momentDate = moment(publishDate);

  let embedUrl = '';

  // I have no idea how to test this in node and in browser
  if (
    embed &&
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  ) {
    embedUrl = window.parent !== window
      ? document.referrer
      : document.location.href;
  }

  const result = {
    embedUrl: embedUrl,
    videoType: _.get(article, 'tags.videoTypes[0]'),
    title: _.get(article, 'title'),
    publishDate: publishDate ? momentDate.format('YYYY-MM-DD HH:mm') : '',
    format: _.includes(_.get(article, 'tags.videoTypes', []), 'program') ? _.get(article, 'tags.programType.name') : '',
    competition: _.get(article, 'tags.competitions[0].en.name'),
    season: _.get(article, 'tags.events[0]'),
    episode: '', // N/A
    category: 'Viasport',
    productionType: 'Viasport',
    webExclusive: 'Yes',
    rights: '', // N/A
    channel: '', // N/A
    country: country,
    daysOnPlay: publishDate ? moment().diff(momentDate, 'days') : '',
    subCategory: _.get(article, 'tags.sports[0].en.name'),
    appVersion: '', // N/A, Native App version
    owner: 'MTG',
    city: '', // N/A
    authenticated: 'No', // Should be replaced with actual status when implemented
    gender: '', // N/A, for logged in users
    age: '', // N/A, for logged in users
    assetId: _.get(video, 'fwAssetId'),
    videoLength: '', // should be provided by player, but don't
    casting: '', // N/A
    adType: '', // provided by player
    platform: embed ? 'embed' : 'web',
    adFilmCode: '', // from player
    cuePoints: _.get(cuePoints, 'length'),
  };

  Object.keys(result)
    .filter(key => !Boolean(result[key]))
    .filter(key => result[key] !== 0)
    .forEach(key => (result[key] = 'N/A'));

  return result;
}

export const VIDEO_MESSAGE = {
  OUTSIDE_REGION: 'outside rgion',
  NOT_FOUND: 'not found',
};

export default new DataLayer();



// WEBPACK FOOTER //
// ./src/service/dataLayer.js